import { ReactNode } from 'react'
import { useReveal } from '../hooks/useReveal'

interface RevealProps {
  children: ReactNode
  className?: string
  delay?: number
  as?: 'div' | 'section' | 'p'
  id?: string
  ariaLabelledby?: string
  ariaLabel?: string
  style?: React.CSSProperties
}

/**
 * Conteneur d'apparition au défilement (fondu + légère montée).
 */
export default function Reveal({
  children,
  className = '',
  delay = 0,
  as = 'div',
  id,
  ariaLabelledby,
  ariaLabel,
  style,
}: RevealProps) {
  const { ref, visible } = useReveal<HTMLDivElement>()
  const Tag = as as keyof JSX.IntrinsicElements

  return (
    <Tag
      ref={ref as never}
      id={id}
      aria-labelledby={ariaLabelledby}
      aria-label={ariaLabel}
      className={`reveal ${visible ? 'is-visible' : ''} ${className}`}
      style={{ transitionDelay: visible ? `${delay}ms` : '0ms', ...style }}
    >
      {children}
    </Tag>
  )
}
